/**
 * 모델
 * @window w_tb_e411w_06
 * @category 담당별고장처리율
 */

export class BreakPercentModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   *
   *
   * **data type** varchar(10)
   */
  readonly perid: string;

  /**
   *
   *
   * **data type** varchar(30)
   */
  readonly divicd: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly divinm: string;

  /**
   *  목표
   *
   * **data type** varchar(40)
   */
  readonly compute_4: string;

  /**
   *  달성율
   *
   * **data type** varchar(40)
   */
  readonly compute_7: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly atdcd: string;

  /**
   *
   *
   * **data type** varchar(12)
   */
  readonly todayplan: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly todaycompplan: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly plancomp: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly notplancomp: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly planyul: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly plancontcnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly plancont001cnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly plancont002cnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly rececompcnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly rececnt: string;

  /**
   *
   *
   * **data type** varchar()
   */
  readonly wadcnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly misplan: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly planmiscnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly planmisamt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly miscnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly misamt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly notkccnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly kccnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly kc001cnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly kc002cnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly contcnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly cont001cnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly cont002cnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly compcnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly costcnt: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly costcompcnt: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly stdate: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly enddate: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly stdate2: string;

  constructor(data: any = {}) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.perid = data.perid || '';
    this.divicd = data.divicd || '';
    this.divinm = data.divinm || '';
    this.compute_4 = data.compute_4 || '';
    this.compute_7 = data.compute_7 || '';
    this.atdcd = data.atdcd || '';
    this.todayplan = data.todayplan || '';
    this.todaycompplan = data.todaycompplan || '';
    this.plancomp = data.plancomp || '';
    this.notplancomp = data.notplancomp || '';
    this.planyul = data.planyul || '';
    this.plancontcnt = data.plancontcnt || '';
    this.plancont001cnt = data.plancont001cnt || '';
    this.plancont002cnt = data.plancont002cnt || '';
    this.rececompcnt = data.rececompcnt || '';
    this.rececnt = data.rececnt || '';
    this.wadcnt = data.wadcnt || '';
    this.misplan = data.misplan || '';
    this.planmiscnt = data.planmiscnt || '';
    this.planmisamt = data.planmisamt || '';
    this.miscnt = data.miscnt || '';
    this.misamt = data.misamt || '';
    this.notkccnt = data.notkccnt || '';
    this.kccnt = data.kccnt || '';
    this.kc001cnt = data.kc001cnt || '';
    this.kc002cnt = data.kc002cnt || '';
    this.contcnt = data.contcnt || '';
    this.cont001cnt = data.cont001cnt || '';
    this.cont002cnt = data.cont002cnt || '';
    this.compcnt = data.compcnt || '';
    this.costcnt = data.costcnt || '';
    this.costcompcnt = data.costcompcnt || '';
    this.stdate = data.stdate || '';
    this.enddate = data.enddate || '';
    this.stdate2 = data.stdate2 || '';
  }
}
